// @flow

import * as React from "react";
import cx from "classnames";
import { type FieldRenderProps } from "react-final-form";

import styles from "./InputWrapper.scss";

type InputProps = $PropertyType<FieldRenderProps, "input">;
type MetaProps = $PropertyType<FieldRenderProps, "meta">;
type InputWrapperProps = {
  children: ?React.Node,
  input: InputProps,
  meta: MetaProps,
  sideSymbol: ?() => React.Node,
  customStyles: ?string,
  isDisabled: boolean
};

const InputWrapper = ({
  children,
  input,
  meta,
  sideSymbol,
  isDisabled,
  customStyles
}: InputWrapperProps) => (
  <div className={cx(styles.inputWrapper, { [styles.disabled]: isDisabled }, customStyles)}>
    {children}
    {sideSymbol && (
      <div
        className={cx({
          [styles.sideSymbol]: true,
          [styles["sideSymbol--active"]]:
            (meta && meta.active) || (input && input.value && !!input.value.length)
        })}
        data-testid="sidesymbol"
      >
        {sideSymbol()}
      </div>
    )}
  </div>
);

InputWrapper.defaultProps = {
  input: null,
  meta: null,
  isDisabled: false,
  customStyles: ""
};

export default InputWrapper;
